import React from 'react';
import AuditLogsTable from './child/AuditLogsTable';

const AuditLogsLayer = () => {
    return (
        <>
            <section className="row gy-4 mt-1">
                <div className="col-12">
                    <AuditLogsTable />
                </div>
            </section>
        </>
    );
};

export default AuditLogsLayer;
